;(function () {
    'use strict';

    $(function () {
        var $feeds     = $('#must-read-feeds');

        if (!$feeds) { return; }

        var $items    = $('.must-read-items-inner');
        var $actions  = $('.must-read-actions-inner');
        var $pager    = $('.must-read-pager');

        var pagerBtns = [];
        var page      = 0;
        var pageWidth = 260;  // ページの横幅
        var interval  = 8000; // 自動遷移のインターバル
        var timer     = setInterval(function() { movePager(page + 1); }, interval);

        // ページャークリックのイベント
        function clickPager(dom) {
            // domのidから要素番号を取得
            var match = dom.id.match(new RegExp("must-read-pager-(.*)+"));
            if (match) { paging(match[1] - 1); }
        }

        // タイマー用の遷移イベント
        function movePager(i) {
            var next = $('#must-read-pager-' + (i + 1));
            if (next.size() === 1) { paging(i); };
        }

        // ページングメソッド
        function paging(i) {
            var $pagerBtn = pagerBtns[i];
            if ($pagerBtn.hasClass('is-active')) { return; }

            // 自動遷移の移動幅
            var moveWidth = -1 * pageWidth * i;

            // itemsにtranslateXを追加
            $items[0].style.transform = "translateX(" + moveWidth + "px)";

            // actionsにtranslateXを追加
            $actions[0].style.transform = "translateX(" + moveWidth + "px)";

            // is-activeを解除
            var $activePagerBtn = $pager.find('.is-active');
            $activePagerBtn.removeClass('is-active');

            // is-activeを追加
            $pagerBtn.addClass('is-active');

            // ページ番号の保持とリセット
            if (i === pagerBtns.length - 1) { page = -1; }
            else                            { page =  i; }
        }

        // 自動遷移タイマーのリセット
        function resetTimer() {
            clearInterval(timer);
            timer = setInterval(function() { movePager(page + 1); }, interval);
        }

        // ページャードットのイベント付与とリスト化
        for (var i = 1; i <= 5; i += 1) {
            var $pagerBtn = $('#must-read-pager-' + i);
            if (!$pagerBtn) { break; }

            $pagerBtn.click(function() {
                resetTimer();
                clickPager(this);
            });
            pagerBtns.push($pagerBtn);
        }
    });
}.call(this));
